import axios from 'axios';

export default class psProfileFavorites {
    constructor() {
        const openButton = document.getElementById('profile-favorites');
        const menu = openButton && document.getElementById(openButton.getAttribute('aria-controls'));

        if (!menu) {
            return;
        }

        this.openButton = openButton;
        this.menu = menu;

        this._init();
    }

    _init() {
        const editButton = document.getElementById('edit-favorites');
        const favorites = document.getElementById('updatedfavorites');
        const loader = document.querySelector('#favorites-section .favorites-ajax-loading');

        const toggleLoader = visible => loader.toggleAttribute('hidden', !visible);

        // Öppna/stäng meny
        this.openButton.addEventListener('click', () => this._toggleMenu(true));
        document.getElementById('profile-favorites-close').addEventListener('click', () => this._toggleMenu(false));

        // Redigering
        editButton.addEventListener('click', () => {
            const enabled = editButton.classList.toggle('setting-icon--check-icon');
            for (const btn of favorites.querySelectorAll('.favorite-item__remove')) {
                btn.toggleAttribute('hidden', !enabled);
            }
        });

        // Borttagning
        favorites.addEventListener('click', async event => {
            const trigger = event.target;

            if (!trigger.classList.contains('favorite-item__remove')) {
                return;
            }

            event.preventDefault();
            toggleLoader(true);

            try {
                await axios.post('/api/ps/profile/favorites/remove', { id: trigger.getAttribute('data-id') });

                for (const btn of document.querySelectorAll('#page-container .profile__favorite-page-toggle')) {
                    btn.classList.remove('added');
                }

                const item = trigger.closest('.favorite-item');
                item && item.remove();
            }
            catch (error) {
                this._error(error);
            };

            toggleLoader(false);
        });

        // Hantera lägg till/favorisera
        document.getElementById('main-content').addEventListener('click', async event => {
            const trigger = event.target;

            if (!trigger.classList.contains('profile__favorite-page-toggle')) {
                return;
            }

            event.preventDefault();
            const added = trigger.classList.contains('added');
            const id = trigger.getAttribute('data-id');

            toggleLoader(true);

            try {
                await axios.post(`/api/ps/profile/favorites/${added ? "remove" : "add"}`, { id });

                for (const btn of document.querySelectorAll(`#page-container .profile__favorite-page-toggle[data-id='${id}']`)) {
                    btn.classList.toggle('added', !added);
                }

                const response = await axios.get('/api/ps/profile/favorites');
                favorites.innerHTML = response.data
            } catch (error) {
                this._error(error);
            }

            toggleLoader(false);
        });
    }

    _toggleMenu(visible) {
        this.openButton.setAttribute('aria-expanded', visible);
        this.menu.toggleAttribute('hidden', !visible);
    }

    _error(error) {
        const id = error && error.response && error.response.status === 401 ? 'ps-profile-logged-out' : 'ps-profile-generic-error';
        const node = document.getElementById(id);
        node && alert(node.value);
    }
}
